import Vue from 'vue';
import { getGlobalConfig } from '../../axiosHandler/interface';

const state = {
  data: null
};

const getters = {

};

const mutations = {
  init(state, { data }) {
  	state.data = data;
  }
};

const actions = {
  init({ commit, state }) {
    getGlobalConfig().then((response) => {
      const { data } = response;
		  commit('init', { data });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js